import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.css';
import Agendamento from './componentes/agendamento/agendamento';

function App() {

  function CatchAllRedirect() {
    const location = useLocation();
    const path = location.pathname.slice(1); 
  
    return <Navigate to={`/?${path}`} replace />;
  }

  return (
    <>
      <ToastContainer position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path={`/`} element={<Agendamento />} />
          <Route path="*" element={<CatchAllRedirect />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
